import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';

export interface ForfeitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  reason: string;
  onReasonChange: (value: string) => void;
  skipAcknowledgement: boolean;
  onSkipAcknowledgementChange: (value: boolean) => void;
  pending: boolean;
  onConfirm: () => void;
}

export function ForfeitDialog(props: ForfeitDialogProps): JSX.Element {
  const canConfirm = props.reason.trim().length >= 8 && !props.pending;
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Forfeit order</DialogTitle>
          <DialogDescription>
            Enter the reason this order will not be processed.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Textarea
            value={props.reason}
            onChange={(event) => props.onReasonChange(event.target.value)}
            placeholder="Reason for rejecting this order"
            className="min-h-[120px]"
          />
          <label className="flex items-center gap-2 text-sm text-muted-foreground">
            <input
              type="checkbox"
              checked={props.skipAcknowledgement}
              onChange={(event) => props.onSkipAcknowledgementChange(event.target.checked)}
              className="h-4 w-4 rounded border"
            />
            Do not acknowledge to customer
          </label>
        </div>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={() => props.onOpenChange(false)}
            disabled={props.pending}
          >
            Cancel
          </Button>
          <Button variant="destructive" onClick={props.onConfirm} disabled={!canConfirm}>
            <XCircle className="h-4 w-4" />
            Forfeit order
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
